export interface CashBackStatus {
  coinsAmount: number;
  minimumSum: number;
}
